module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-36.7ad2f03.woff2";